import { render, staticRenderFns } from "./Promotion.vue?vue&type=template&id=62b34a03"
import script from "./Promotion.ts?vue&type=script&lang=ts&external"
export * from "./Promotion.ts?vue&type=script&lang=ts&external"
import style0 from "./Promotion.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports